module.exports = __webpack_public_path__ + "img/t6-blue.66124210.png";